import { ArrowUpRight, Phone } from "lucide-react";
import React from "react";
import { Link } from "wouter";
import { realPhotos, siteConfig } from "@/data/site";

type QuoteBandProps = {
  title?: string;
  copy?: string;
  quoteHref?: string;
};

export function QuoteBand({
  title = "Send the plans. Get a clear path forward.",
  copy = "Tell us what you are building, replacing, or specifying. Our team will help organize the partition material, accessories, and quantities for your commercial restroom project.",
  quoteHref = "/request-a-quote",
}: QuoteBandProps) {
  return (
    <section className="quote-band section-line" aria-labelledby="quote-band-title">
      <div className="quote-band__art" aria-hidden="true">
        <img
          src={realPhotos.projects.dark.large}
          srcSet={`${realPhotos.projects.dark.small} 720w, ${realPhotos.projects.dark.large} 1280w`}
          sizes="(max-width: 820px) 100vw, 34vw"
          width="1280"
          height="960"
          alt=""
          loading="lazy"
        />
      </div>
      <div className="quote-band__content">
        <span className="kicker">Project-ready support</span>
        <h2 id="quote-band-title">{title}</h2>
        <p>{copy}</p>
        <div className="button-row">
          <Link href={quoteHref} className="button button--primary">
            Request a Quote <ArrowUpRight aria-hidden="true" />
          </Link>
          <a href={`tel:${siteConfig.phoneHref}`} className="button button--outline">
            <Phone aria-hidden="true" /> Call {siteConfig.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
}
